import { MainLayout } from '@/widgets/layouts/main/main-layout';

import { PageSeo } from '@/shared/lib/seo';

import { CatalogMain } from './main';

export const CatalogPage = () => {
  return (
    <>
      <PageSeo
        title="каталог"
        description="Каталог Азимут - надежного поставщика качественного строительного крепежа торговых марок RAWLPLUG, ELEMENTA, GRAF, FISCHER в Омске."
      />

      <CatalogMain />
    </>
  );
};

CatalogPage.Layout = MainLayout;
